import {
  SET
} from 'reducer/types/prefix'

export const REQUEST_REASON = 'REQUEST_REASON'

export const SET_REQUEST_REASON = `${SET}${REQUEST_REASON}`